import MedicationReminders from './MedicationReminders';
export default MedicationReminders;
